import React, { createContext, useContext, useState, useCallback } from 'react';

const WorkflowContext = createContext(null);

export const WorkflowProvider = ({ children }) => {
  const [workflow, setWorkflow] = useState({
    topic: '',
    keywords: '',
    content: '',
    contentType: '',
    targetTool: '',
    sourceTool: '',
    sourceGod: '',
    leadData: null,
    actionItem: '',
    competitorGap: '',
    active: false,
  });

  // Navigation callback — set by MainApp
  const [onNavigate, setOnNavigate] = useState(null);

  const startRiver = useCallback((data) => {
    setWorkflow({ ...data, active: true });
    // Trigger navigation if callback is set
    if (onNavigate) onNavigate(data);
  }, [onNavigate]);

  const clearRiver = useCallback(() => {
    setWorkflow({
      topic: '', keywords: '', content: '', contentType: '',
      targetTool: '', sourceTool: '', sourceGod: '', leadData: null,
      actionItem: '', competitorGap: '', active: false,
    });
  }, []);

  const consumeRiver = useCallback(() => {
    const current = { ...workflow };
    return current;
  }, [workflow]);

  const registerNavigator = useCallback((fn) => {
    setOnNavigate(() => fn);
  }, []);

  return (
    <WorkflowContext.Provider value={{ workflow, startRiver, clearRiver, consumeRiver, registerNavigator }}>
      {children}
    </WorkflowContext.Provider>
  );
};

export const useWorkflow = () => {
  const ctx = useContext(WorkflowContext);
  if (!ctx) throw new Error('useWorkflow must be used within WorkflowProvider');
  return ctx;
};

export default WorkflowContext;
